import withLazyImport from '../../../common/hoc/with-lazy-import';

export default withLazyImport(() =>
  import(/* webpackChunkName: "rich-content-fullscreen" */ 'wix-rich-content-fullscreen/dist/module.cjs'),
);
